import {AfterViewInit, ChangeDetectionStrategy, Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {init} from 'protractor/built/launcher';
import {CHITIKA_TOKEN, ChitikaConfig} from './chitika-config';

@Component({
  selector: 'ng-chitika',
  template: `
    <div [ngStyle]="{'display': display, 'width.px': 0, 'height.px': 0 }" [id]="'chitikaAdBlock-' + adBlockId"
         class="chitikaAdContainer"
         #ins>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NgChitikaComponent implements OnInit, AfterViewInit {
  @ViewChild('ins') ins: any;

  @Input() adType: AdType = AdType.WideSkyscraper;
  @Input() display: string = 'inline';

  adBlockId = '0';


  constructor(@Inject(CHITIKA_TOKEN) private config: ChitikaConfig) {
  }

  ngOnInit() {
    this.initElement();

    const load = new Promise((resolve) => {
      this.loadScript();
      resolve(true);
    });
  }

  initElement() {
    if (window['CHITIKA'] === undefined) {
      window['CHITIKA'] = {'units': []};
    }

    const unit = {
      'calltype': 'async[2]',
      'publisher': this.config.publisher,
      'width': AdSizes[this.adType].x,
      'height': AdSizes[this.adType].y,
      'sid': 'Chitika Default'
    };
    this.adBlockId = window['CHITIKA'].units.push(unit);
  }

  public loadScript() {
    const dynamicScripts = ['//cdn.chitika.net/getads.js'];

    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts [i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

  ngAfterViewInit(): void {
    this.initElement();

    const load = new Promise((resolve) => {
      this.loadScript();
      resolve(true);
    });
  }

}

enum AdType {
  WideSkyscraper = 'wideSkyscraper',
  Rectange = 'rectangle',
  MobileBanner = 'mobileBanner',
  HalfPageBanner = 'halfPageBanner',
  MegaUnit = 'megaUnit',
  Leaderboard = 'leaderboard'
}

const AdSizes = {
  'wideSkyscraper': {x: 160, y: 600},
  'rectangle': {x: 300, y: 250},
  'mobileBanner': {x: 320, y: 50},
  'halfPageBanner': {x: 300, y: 600},
  'megaUnit': {x: 550, y: 250},
  'leaderboard': {x: 728, y: 90}
};
